import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LoginPage } from "./components/auth/LoginPage";
import { UserManagement } from "./Pages/UserManagement";
import { UserManagement as AdminUserManagement } from "./components/users/UserManagement";
import { InventoryManagement } from "./Pages/InventoryManagement";
import { ManualCouponAdjustmentManagement } from "./Pages/ManualCouponAdjustmentManagement";
import { Layout } from "./components/layout";
import { Outlet, useNavigate } from "react-router-dom";
import { ProductManagement } from "./Pages/ProductManagement";
import { Toaster } from 'react-hot-toast';
import { OrdersView } from "./Pages/OrderManagement";
import { SubscriptionManagement } from "./Pages/SubscriptionManagement";
import OngoingDeliveryManagement from "./Pages/OngoingDeliveryManagement";
import { OrderDetails } from "./Pages/OrderDetails";
import { SubscriptionDetails } from "./Pages/SubscriptionDetails";
import { CouponManagement } from "./Pages/CouponManagement";
import BannerManagement from "./Pages/BannerManagement";
import CustomNotification from "./Pages/CustomNotification";
import HelpPage from "./Pages/HelpPage";

// Protected Route
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

const LayoutWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Strips the leading "/" → "ongoing", "orders", etc.
  const activeTab = location.pathname.split("/")[1];

  return (
    <Layout activeTab={activeTab} onTabChange={(tab) => navigate(`/${tab}`)}>
      <Outlet />
    </Layout>
  );
};

// Login Wrapper
const LoginWrapper = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  if (token) return <Navigate to="/ongoing" replace />;

  return <LoginPage onLogin={() => navigate("/ongoing")} />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Login */}
        <Route path="/login" element={<LoginWrapper />} />
        
        <Route
          path="/help"
          element={<Navigate to="/help/account-deletion" replace />}
        />

        <Route
          path="/help/:section"
          element={<HelpPage />}
        />

        {/* Protected */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <LayoutWrapper />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="ongoing" replace />} />
          <Route path="ongoing" element={<OngoingDeliveryManagement />} />
          <Route path="orders" element={<OrdersView />} />
          <Route path="orders/:id" element={<OrderDetails />} />
          <Route path="subscriptions" element={<SubscriptionManagement />} />
          <Route path="subscriptions/:id" element={<SubscriptionDetails />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="admin-users" element={<AdminUserManagement />} />
          <Route path="products" element={<ProductManagement />} />
          <Route path="inventory" element={<InventoryManagement />} />
          <Route path="manual-coupon-adjustments" element={<ManualCouponAdjustmentManagement />} />
          <Route path="coupons" element={<CouponManagement />} /> 
          <Route path="banners" element={<BannerManagement />} /> 
          <Route path="custom-notifications" element={<CustomNotification />} />
        </Route>

      </Routes>

      <Toaster position="top-center" />
    </BrowserRouter>
  );
}
